import { useState } from 'react';
import { FormControl, Stack, FormLabel, Box } from '@chakra-ui/react';
import { Field } from 'formik';
import { usePartnerForm } from '../../hooks/usePartnerForm';
import EmailField from '@/components/forms/new/formikFormFields/EmailField';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import { FORM_FIELD_PATHS } from '../../constants';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
} from 'components/forms/new/formStyles';

const PrimaryContactEmail = ({ darkMode, errors, touched }) => {
    const [isHovered, setIsHovered] = useState(false);
    const { formData, updateFormData } = usePartnerForm();

    const handleChange = (e) => {
        updateFormData(FORM_FIELD_PATHS.PRIMARY_CONTACT_EMAIL, e.target.value);
    };

    const hasError =
        !!errors?.primaryContactEmail && touched?.primaryContactEmail;

    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={hasError}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack direction="row" spacing={stackSpacing} sx={stackStyling()}>
                <FormLabel sx={formLabelStyling(darkMode)}>
                    Primary Contact Email
                </FormLabel>
                <Box flex={1} maxWidth="400px">
                    <Field
                        component={EmailField}
                        id="primaryContactEmail"
                        name="primaryContactEmail"
                        value={formData?.primaryContactEmail || ''}
                        onChange={handleChange}
                        placeholder="Enter primary contact email"
                        width="100%"
                        darkMode={darkMode}
                        isInvalid={hasError}
                    />
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label="Enter the email address of the primary contact person"
                        ariaLabel="primary-contact-email-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default PrimaryContactEmail;
